import Vue from 'vue';

$.fn.extend({
    makeVueApp(optionalConfig) {
        const config = optionalConfig || {};
        config.el = `#${this.attr('id')}`;

        if ($(config.el).length === 0) {
            throw new Error('Cannot create Vue App due to invalid ID or null element');
        }

        if (!('beforeMount' in config)) {
            config.beforeMount = () => {
                $(config.el).find('.loading').remove();
            };
        }

        const data = this.data();
        if (!config.data) {
            config.data = {};
        }
        const load = {};

        Object.keys(data).forEach((key) => {
            let property;
            switch (true) {
                case key.substr(0, 4) === 'load':
                    property = key.substr(4, 1).toLowerCase() + key.substring(5);
                    load[property] = data[key];
                    config.data[property] = {};
                    config.load = load;
                    $(config.el).attr(`data-load-${property}`, null);
                    break;

                case key.substr(0, 3) === 'use':
                    property = key.substr(3, 1).toLowerCase() + key.substring(4);
                    if (data[key] !== null && data[key] !== '') {
                        let datum = data[key];
                        if (typeof datum === 'string') {
                            datum = decodeURIComponent(datum.replace(/\+/g, ' '));
                        }
                        config.data[property] = JSON.parse(datum);
                    } else {
                        config.data[property] = null;
                    }
                    $(config.el).attr(`data-use-${property}`, null);
                    break;

                default:
                    break;
            }
        });

        const app = new Vue(config);

        if (config.load) {
            Object.keys(config.load).forEach((key) => {
                app[key] = {};
                fetch(config.load[key], {
                    credentials: 'same-origin',
                })
                    .then((response) => response.json())
                    .then((response) => {
                        app[key] = response;
                    });
            });
        }
        return app;
    },
});
